enum TransactionState {
  None = 0,
  Uncommitted = 1,
  Committed = 2,
  Void = 3,
  UncommittedVoid = 4,
}

export { TransactionState };
